"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const gatsby_1 = require("gatsby");
function SEO(_ref) {
    var _site$siteMetadata, _site$siteMetadata2, _site$siteMetadata3;
    var _ref$description = _ref.description, description = _ref$description === void 0 ? '' : _ref$description, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? 'en' : _ref$lang, _ref$meta = _ref.meta, meta = _ref$meta === void 0 ? [] : _ref$meta, title = _ref.title;
    var _useStaticQuery = gatsby_1.useStaticQuery("196133661"), site = _useStaticQuery.site;
    var metaDescription = description || (site === null || site === void 0 ? void 0 : (_site$siteMetadata = site.siteMetadata) === null || _site$siteMetadata === void 0 ? void 0 : _site$siteMetadata.description) || '';
    var author = (site === null || site === void 0 ? void 0 : (_site$siteMetadata2 = site.siteMetadata) === null || _site$siteMetadata2 === void 0 ? void 0 : _site$siteMetadata2.author) || '';
    var titleTemplate = (site === null || site === void 0 ? void 0 : (_site$siteMetadata3 = site.siteMetadata) === null || _site$siteMetadata3 === void 0 ? void 0 : _site$siteMetadata3.title) || '';
    return /*#__PURE__*/ react_1.default.createElement(react_helmet_1.default, {
        htmlAttributes: {
            lang: lang
        },
        title: title,
        titleTemplate: "%s | " + titleTemplate,
        meta: [{
                name: "description",
                content: metaDescription
            }, {
                property: "og:title",
                content: title
            }, {
                property: "og:description",
                content: metaDescription
            }, {
                property: "og:type",
                content: "website"
            }, {
                name: "twitter:card",
                content: "summary"
            }, {
                name: "twitter:creator",
                content: author
            }, {
                name: "twitter:title",
                content: title
            }, {
                name: "twitter:description",
                content: metaDescription
            }].concat(meta || [])
    });
}
exports.default = SEO;
